import { ANALYTICS_STATISTICS_PATH } from 'common/selectors/sidebar/common';
import buildUrl from 'common/helpers/buildUrl';

const getStatisticsLinkWithGivenParams = (
  params: Record<string, any>,
): string =>
  buildUrl({
    url: ANALYTICS_STATISTICS_PATH,
    params: { ...params, autoSubmit: true },
    qsParams: { arrayFormat: 'indices', encodeValuesOnly: true },
  });

export default getStatisticsLinkWithGivenParams;
